module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page checkout company-context"
  }, [_c('transition', {
    attrs: {
      "tag": "section",
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "space-30"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-699d7564!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 355
// module chunks = 12